import { Alert, Button, Stack } from '@dtx-company/design-system/src'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import React from 'react'
import ResendVerificationEmailButton from '../ResendVerificationEmailButton'
import useTranslation from 'next-translate/useTranslation'

const FailureBanner: React.FC = () => {
  const { t } = useTranslation('email-verification')

  const copy = t('views.FailureBanner.CTA')
  const buttonCopy = t('views.FailureBanner.ContactUs')

  return (
    <Alert
      severity="error"
      action={
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
          <ResendVerificationEmailButton
            additionalCallback={() => {
              fireAnalyticsEvent('EmailVerif_ErrorBanner_Clicked_ResendEmail')
            }}
          />
          <Button
            onClick={() => {
              fireAnalyticsEvent('EmailVerif_ErrorBanner_Clicked_ContactUs')
            }}
            href="mailto:support@flowcode.com"
          >
            {buttonCopy}
          </Button>
        </Stack>
      }
    >
      {copy}
    </Alert>
  )
}

export default FailureBanner
